// extracted by mini-css-extract-plugin
module.exports = {"modal__comment-button":"_36yeDafaJqz07I6570TFHm","modal__text-area":"DIdJTk6NA6XfIkkstIhWb"};